import { render, staticRenderFns } from "./VesselInfo.vue?vue&type=template&id=48217369&scoped=true&"
import script from "./VesselInfo.vue?vue&type=script&lang=js&"
export * from "./VesselInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48217369",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardTitle,VContainer,VFlex,VLayout})
